'use client';

import Script from 'next/script';

/* Google Tag Manager for the marketing site, carrying the Google Ads tags and
   the consent signals ConsentBanner pushes. The Meta pixel deliberately does
   NOT run through here — it loads directly in MetaPixel — so nothing in this
   container should fire a Meta tag or events would double-count.

   The id is public — it ships in the HTML to every visitor.

   The nonce lets the CSP run this inline snippet, and is copied onto gtm.js so
   the container can stamp it on the Custom HTML tags it injects. */
const GTM_ID = 'GTM-MXP8MTDN';

export function GtmLoader({ nonce }: { nonce?: string }) {
  return (
    <Script id="cultiv-gtm" strategy="afterInteractive" nonce={nonce}>
      {`(function(w,d,s,l,i,n){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;if(n)j.setAttribute('nonce',n);f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}','${nonce ?? ''}');`}
    </Script>
  );
}
